import script from "./announceView.vue?vue&type=script&setup=true&lang=js"
export * from "./announceView.vue?vue&type=script&setup=true&lang=js"

import "./announceView.vue?vue&type=style&index=0&id=107b4d83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107b4d83"]])

export default __exports__